import { ProductDisplayModel } from '@shared/models/components/ProductDisplayModel';
import { AllLicenseTypes } from '@shared/models/organizations/AllLicenseTypes';
import { getBaseApiUrl } from '../Urls';

export const compareFeaturesLink = 'https://cephable.com/pricing/#matrix';
export const productResources: Record<AllLicenseTypes, ProductDisplayModel> = {
    personal: {
        icon: {
            light: 'personalLogo',
            dark: 'personalLogoWhite',
        },
        title: 'common:billing.personal.titleLong',
        description: 'common:billing.personal.description',
        licenseType: 'personal',
    },
    isPlusAccess: {
        icon: {
            light: 'plusLogo',
            dark: 'plusLogoWhite',
        },
        title: 'common:billing.isPlusAccess.titleLong',
        description: 'common:billing.isPlusAccess.description',
        // trial: `${getBaseApiUrl()}/trial/plus`,
        licenseType: 'isPlusAccess',
    },
    isEmployeeAccess: {
        icon: {
            light: 'proLogo',
            dark: 'proLogoWhite',
        },
        title: 'common:billing.isEmployeeAccess.titleLong',
        description: 'common:billing.isEmployeeAccess.description',
        trial: `${getBaseApiUrl()}/trial`,
        licenseType: 'isEmployeeAccess',
    },
    isStudentAccess: {
        icon: {
            light: 'eduLogo',
            dark: 'eduLogoWhite',
        },
        title: 'common:billing.isStudentAccess.titleLong',
        description: 'common:billing.isStudentAccess.description',
        // trial: `${getBaseApiUrl()}/trial/education`,
        licenseType: 'isStudentAccess',
    },
    isDeveloperAccess: {
        icon: {
            light: 'sdkLogo',
            dark: 'sdkLogoWhite',
        },
        title: 'common:billing.isDeveloperAccess.titleLong',
        description: 'common:billing.isDeveloperAccess.description',
        // trial: `${getBaseApiUrl()}/trial/developers`,
        licenseType: 'isDeveloperAccess',
    },
};
